"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;



































































var _formatter = require("@/utils/formatter");
var _popProtocolTree = _interopRequireDefault(require("./popProtocolTree")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'PopProtocol', components: { CodeTree: _popProtocolTree.default }, data: function data() {return { tableData: [], // 列表数据
      handleShowCode: false, searchData: { deviceTypeCode: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, addData: { id: '', deviceTypeCode: '' }, // 表格列
      tableColumns: [{ prop: 'deviceTypeCode', label: '椅子型号编码', isShow: true // 是否显示
      }, { prop: 'protocolVersion', label: '模型版本号', isShow: true // 是否显示
      }, { prop: 'isEnabled', label: '启、禁用', formatter: _formatter.statusFormatter, isShow: true // 是否显示
      }], detailsearchData: { id: '', name: '', code: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, pageData2: { page: 1, rows: 10, total: 0, pages: 1 } };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/deviceModelProtocol', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, resetFun: function resetFun() {// 重置
      this.searchData.deviceTypeCode = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    onCencal: function onCencal() {
      this.$refs['addForm'].resetFields();
    },
    handleCheckCode: function handleCheckCode() {
      var self = this;
      if (!self.addData.id) {
        self.$message({
          message: '请选择协议!',
          type: 'error' });

      } else {
        self.handleShowCode = true;
        if (self.$refs.codeTree) {
          self.$refs.codeTree.init(self.addData.id);
        }
      }
    },
    handleAffirmCode: function handleAffirmCode() {
      var self = this;
      self.handleShowCode = false;
      console.log('22222');
      if (self.$refs.codeTree) {
        self.$emit('handleSetProtocol', self.addData, self.$refs.codeTree.handleCheckList);
        console.log('treeCode->', self.$refs.codeTree.handleCheckList);
      }
    },
    getCurrentRow: function getCurrentRow(event) {
      this.addData.deviceTypeCode = event.deviceTypeCode;
    } } };exports.default = _default;